import { render, staticRenderFns } from "./alert-list.vue?vue&type=template&id=6c1dd657&scoped=true&"
import script from "./alert-list.vue?vue&type=script&lang=ts&"
export * from "./alert-list.vue?vue&type=script&lang=ts&"
import style0 from "./alert-list.vue?vue&type=style&index=0&id=6c1dd657&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1dd657",
  null
  
)

export default component.exports